require('./general');
require('./pdf');



// WEBPACK FOOTER //
// ./resources/js/regular/index.js